import { asPage } from 'src/components/hoc/asPage'
import { NoticeConfiguration } from 'src/compositions/Profile/NoticeConfiguration'

export default asPage(NoticeConfiguration, { pageTitle: '通知設定' })
